import React from 'react';
import { ProdutoIntegrado, TipoProduto, isMapaResultados, isMotorConciliacao, isRevisorContabil, isWorkflowSox } from '../models/produtos';
import { formatarMoeda } from '../utils/formatters';
import { ICONE_PRODUTO, LABEL_PRODUTO } from '../utils/labels';

/** Card consolidado por tipo de produto, somando/agregando todas as empresas do escopo selecionado. */
const ProdutoTotalCard: React.FC<{ tipo: TipoProduto; produtos: ProdutoIntegrado[] }> = ({ tipo, produtos }) => {
  const linhas: Array<[string, string]> = [];
  let percentual: number | undefined = 0;

  if (tipo === 'MOTOR_CONCILIACAO') {
    const lista = produtos.filter(isMotorConciliacao);
    const contasTotais = lista.reduce((s, p) => s + p.contasTotais, 0);
    const contasConcluidas = lista.reduce((s, p) => s + p.contasConcluidas, 0);
    percentual = contasTotais ? Math.round((contasConcluidas / contasTotais) * 100) : 0;
    linhas.push(['Contas concluídas', `${contasConcluidas}/${contasTotais}`]);
    linhas.push(['Contas pendentes', String(lista.reduce((s, p) => s + p.contasPendentes, 0))]);
    linhas.push(['Contas com divergência', String(lista.reduce((s, p) => s + p.contasComDivergencia, 0))]);
    linhas.push(['Diferença a conciliar', formatarMoeda(lista.reduce((s, p) => s + p.diferencaAConciliar, 0))]);
  } else if (tipo === 'MAPA_RESULTADOS') {
    const lista = produtos.filter(isMapaResultados);
    const contasTotais = lista.reduce((s, p) => s + p.contasTotais, 0);
    const contasConcluidas = lista.reduce((s, p) => s + p.contasConcluidas, 0);
    percentual = contasTotais ? Math.round((contasConcluidas / contasTotais) * 100) : 0;
    linhas.push(['Contas concluídas', `${contasConcluidas}/${contasTotais}`]);
    linhas.push(['Contas pendentes', String(lista.reduce((s, p) => s + p.contasPendentes, 0))]);
    linhas.push(['Contas com divergência', String(lista.reduce((s, p) => s + p.contasComDivergencia, 0))]);
  } else if (tipo === 'REVISOR_CONTABIL') {
    const lista = produtos.filter(isRevisorContabil);
    const modulosAvaliados = lista.reduce((s, p) => s + p.modulosAvaliados, 0);
    const modulosComFalha = lista.reduce((s, p) => s + p.modulosComFalha, 0);
    percentual = modulosAvaliados ? Math.round(((modulosAvaliados - modulosComFalha) / modulosAvaliados) * 100) : 0;
    linhas.push(['Erros', String(lista.reduce((s, p) => s + p.erros, 0))]);
    linhas.push(['Alertas', String(lista.reduce((s, p) => s + p.alertas, 0))]);
    linhas.push(['Avisos', String(lista.reduce((s, p) => s + p.avisos, 0))]);
    linhas.push(['Impacto total estimado', formatarMoeda(lista.reduce((s, p) => s + p.impactoTotalEstimado, 0))]);
  } else {
    const lista = produtos.filter(isWorkflowSox);
    percentual = undefined;
    linhas.push(['Itens na fila', String(lista.reduce((s, p) => s + p.itensNaFila, 0))]);
    linhas.push(['Em alerta (SLA amarelo)', String(lista.reduce((s, p) => s + p.emAlerta, 0))]);
    linhas.push(['Fora do prazo (SLA vermelho)', String(lista.reduce((s, p) => s + p.foraDoPrazo, 0))]);
  }

  return (
    <div className='mc-produto-card mc-produto-card--total'>
      <div className='mc-produto-card__topo'>
        <span className='mc-produto-card__icone'><i className={ICONE_PRODUTO[tipo]} /></span>
        <div>
          <strong>{LABEL_PRODUTO[tipo]}</strong>
          <small>Total — {produtos.length} empresa{produtos.length > 1 ? 's' : ''}</small>
        </div>
      </div>
      {percentual !== undefined && (
        <div className='mc-progress'><div className='mc-progress__track'><div style={{ width: `${percentual}%` }} /></div><span>{percentual}%</span></div>
      )}
      <dl className='mc-produto-card__dados'>
        {linhas.map(([rotulo, valor]) => <div key={rotulo}><dt>{rotulo}</dt><dd>{valor}</dd></div>)}
      </dl>
    </div>
  );
};

export default ProdutoTotalCard;
